
import { defineComponent, reactive, computed, shallowRef } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import {
  MailOutlined,
  LockOutlined,
  CodeOutlined,
  BulbOutlined,
  BoxPlotOutlined,
  RocketOutlined
} from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { GlobalDataProps } from '../store/index'

interface RuleFormInstance {
  validate: () => Promise<any>
}

export default defineComponent({
  name: 'Login',
  components: {
    MailOutlined,
    LockOutlined,
    CodeOutlined,
    BulbOutlined,
    BoxPlotOutlined,
    RocketOutlined
  },
  setup() {
    const store = useStore<GlobalDataProps>()
    const isLoginLoading = computed(() => store.getters.isOpLoading('login'))
    const router = useRouter()
    const loginForm = shallowRef()

    const isProduction = process.env.NODE_ENV === 'production'
    const form = reactive({
      cellphone: isProduction ? '' : 'root@lego.com',
      verifyCode: isProduction ? '' : 'Admin1234',
      rememberMe: false
    })

    const rules = reactive({
      cellphone: [{ required: true, message: 'Please enter your email', trigger: 'blur' }],
      verifyCode: [{ required: true, message: 'Please enter your password', trigger: 'blur' }]
    })

    const login = async () => {
      console.log('Current form values:', form)
      try {
        // 直接使用 loginForm 的 validate 方法
        await loginForm.value.validate()
        console.log('Form validated successfully')
        const payload = {
          username: form.cellphone,
          password: form.verifyCode
        }
        await store.dispatch('loginAndFetch', { data: payload })
        message.success('登录成功')
        setTimeout(() => {
          router.push('/')
        }, 500)
      } catch (error: any) {
        console.log('Validation/login error:', error)
        // 验证失败时会进入这里
        if (error.errorFields && error.errorFields.length > 0) {
          // 表单验证错误,显示第一个错误信息
          const firstError = error.errorFields[0]
          message.error(firstError.errors[0])
        } else {
          // 其他错误
          console.error('Login error:', error)
          message.error('登录失败,请稍后重试')
        }
      }
    }

    const goGiteeAuth = async () => {
      const axios = (await import('axios')).default
      const { data } = await axios.get('/users/passport/gitee')
      window.location.href = data.data.url
    }

    const route = useRoute()
    const loginByGitee = async () => {
      const { auth, code } = route.query
      if (auth === 'gitee' && code) {
        store.dispatch('loginByGiteeAndFetch', { data: { code } }).then(() => {
          message.success('登录成功 2秒后跳转首页')
          setTimeout(() => {
            router.push('/')
          }, 2000)
        })
      }
    }
    loginByGitee()

    return {
      form,
      rules,
      loginForm,
      login,
      loginByGitee,
      goGiteeAuth,
      isLoginLoading
    }
  }
})
